"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityContactMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const contact_entity_1 = require("./contact.entity");
let OpportunityContactMap = class OpportunityContactMap {
};
exports.OpportunityContactMap = OpportunityContactMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityContactMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityContactMap.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityContactMap.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityContactMap.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityContactMap.prototype, "contact", void 0);
exports.OpportunityContactMap = OpportunityContactMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_contact_map" }),
    (0, typeorm_1.Unique)(["opportunity", "contact"])
], OpportunityContactMap);
